import axios from "axios";
import Config from "src/config";

const v2_actionAnaliseAtendimento = (data) => {
    return axios({
        method: "post",
        url: `https://api-analysis.lais.app/api/v2/AI/gemini/analyze`,
        data
        });
};

export default v2_actionAnaliseAtendimento;
